import React from "react";
import { T } from "../theme";
import { Btn, Card, SectionTitle } from "../ui";

function Block({ title, children }) {
  return (
    <>
      <SectionTitle>{title}</SectionTitle>
      <Card><div style={{ fontSize: 12.5, color: T.muted, lineHeight: 1.7 }}>{children}</div></Card>
    </>
  );
}

export default function PrivacyScreen({ onBack }) {
  return (
    <div>
      <div style={{ fontSize: 10, color: T.muted, textAlign: "center", marginBottom: 14 }}>
        Last updated August 2026 · Applies to the 8Track Vault app and 8trackvault.com
      </div>

      <Block title="What We Collect">
        Account info you provide directly: your email address, display name, and password (handled by
        Firebase Authentication — we never see or store your raw password ourselves). Collection data
        you enter: tape details, photos, wishlist items, personal ratings, and any marketplace, player,
        or repair listings you create, including whatever contact info you choose to put in a listing's
        description. If you subscribe to a paid tier, Stripe collects and stores your payment details —
        we never see or store your card number.
      </Block>

      <Block title="How We Use It">
        To run the app: storing your collection, matching you to your own data, computing shared
        community and seller ratings, and enforcing subscription tier limits. We don't sell your data,
        run ads, or share it with anyone beyond the service providers below.
      </Block>

      <Block title="Who We Share It With">
        Three services process data on our behalf, each only for what they need to do their job:
        <div style={{ marginTop: 8 }}>
          <strong style={{ color: T.text }}>Firebase (Google Cloud)</strong> — hosts your account, collection
          data, and uploaded photos.
        </div>
        <div style={{ marginTop: 6 }}>
          <strong style={{ color: T.text }}>Stripe</strong> — processes subscription payments if you upgrade.
          Card details go directly to Stripe; we only receive your subscription status.
        </div>
        <div style={{ marginTop: 6 }}>
          <strong style={{ color: T.text }}>Shopify</strong> — powers the Merch tab's product catalog and cart.
          If you check out, that happens on Shopify's own hosted checkout page, outside this app.
        </div>
      </Block>

      <Block title="Marketplace Listings Are Public"><>
        Anything you put in a tape, player, or repair listing — including contact details you choose to
        share — is visible to any other signed-in collector, since that's how the marketplace works.
        Don't include information there you wouldn't want other users to see.
      </></Block>

      <Block title="Your Choices">
        You can export your own collection at any time (Quad-8 and Vault Reserve tiers include CSV/PDF
        export from your Profile). To request a copy of your data, correct it, or have your account and
        associated data deleted, contact us using the email below — there's no self-serve delete button
        in the app yet, so we handle deletion requests manually.
      </Block>

      <Block title="Children">
        8Track Vault isn't directed at children, and we don't knowingly collect data from anyone under 13.
      </Block>

      <Block title="Contact">
        Questions about this policy or your data: <span style={{ color: T.text }}>suttonimpressions.js@gmail.com</span>
      </Block>

      <div style={{ fontSize: 10, color: T.muted, textAlign: "center", marginTop: 4, lineHeight: 1.6 }}>
        This page describes what the app actually does, in plain language. It isn't legal advice, and
        hasn't been reviewed by a lawyer — worth getting real legal review before relying on it for
        formal compliance (GDPR, CCPA, etc.) if the app grows beyond personal/small-scale use.
      </div>

      <Btn variant="outline" onClick={onBack} style={{ width: "100%", marginTop: 16 }}>← Back</Btn>
      <div style={{ height: 20 }} />
    </div>
  );
}
